import { CircularProgress, Popper } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { MdCheckCircleOutline, MdOutlineCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import ModalApproveSfa from "./sfaComponents/ModalApproveSfa";
import PagePagination from "../../common/particles.jsx/PagePagination";
import { getListApprovalSfa } from "../../../services/sfaApi";
import moment from "moment";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const SfaList = () => {
  const navigate = useNavigate();

  const [openActionModal, setOpenActionModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [moreProductArr, setMoreProductArr] = useState([]);
  const [anchorElMoreProduct, setAnchorElMoreProduct] = useState(null);
  const [reqBody, setReqBody] = useState({ limit: 25, offset: 1 });

  const {
    mutate: mutateList,
    data: dataList,
    isLoading: isLoadingList,
  } = useMutation({
    mutationFn: getListApprovalSfa,
  });

  useEffect(() => {
    mutateList(reqBody);
  }, [reqBody]);

  return (
    <div className="text-[12px]">
      <div className="flex w-full mb-4">
        <div className="w-full">
          <div className="block overflow-x-auto w-full rounded-md">
            <table className="w-full overflow-x-auto rounded-md border-collapse">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="p-2 text-center">No</th>
                  <th className="p-2 text-left whitespace-nowrap">
                    Tanggal Order
                  </th>
                  <th className="p-2 text-left whitespace-nowrap">Jam Order</th>
                  <th className="p-2 text-left whitespace-nowrap">Order ID</th>
                  <th className="p-2 text-left whitespace-nowrap">No SP/PO</th>
                  <th className="p-2 text-left whitespace-nowrap">Sumber PO</th>
                  <th className="p-2 text-left whitespace-nowrap min-w-[250px]">
                    Produk
                  </th>
                  <th className="p-2 text-left whitespace-nowrap">
                    Total Harga
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {dataList && !isLoadingList && dataList.count > 0 ? (
                  dataList.data.map((item, i) => (
                    <tr className="border" key={i}>
                      <td className="p-2 text-center">
                        {(reqBody.offset - 1) * reqBody.limit + (i + 1)}
                      </td>
                      <td className="p-2 text-left">
                        {moment(item.order_date).format("DD/MM/YYYY")}
                      </td>
                      <td className="p-2 text-left">{item.order_time}</td>
                      <td
                        className="p-2 text-left text-blue-500 hover:text-gray-300 cursor-pointer text-nowrap"
                        onClick={() =>
                          navigate(`/sfa/detail/${item.order_number}`)
                        }
                      >
                        {item.order_number}
                      </td>
                      <td className="p-2 text-left">{item.po_number}</td>
                      <td className="p-2 text-left">
                        {item.po_source === "" ? "-" : item.po_source}
                      </td>
                      <td className="p-2 text-left">
                        <div className="w-full flex justify-between gap-4 items-center">
                          <p>
                            {item.product_name ? item.product_name[0] : "-"}
                          </p>
                          {item.product_name && item.product_name.length > 1 ? (
                            <p
                              className="text-blue-500 cursor-pointer text-nowrap whitespace-nowrap"
                              onMouseEnter={(e) => {
                                setMoreProductArr(item.product_name.slice(1));
                                setAnchorElMoreProduct(e.currentTarget);
                              }}
                              onMouseLeave={() => setAnchorElMoreProduct(null)}
                            >
                              +{item.product_name.length - 1} Lainnya
                            </p>
                          ) : null}
                        </div>
                      </td>
                      <td className="p-2 text-left">
                        {toIDR(item.total_price)}
                      </td>
                      <td className="p-2 text-left">
                        {item.status === 0 ? (
                          <div className="flex gap-2 items-center justify-center">
                            <MdOutlineCancel
                              className="text-[18px] text-red-500 cursor-pointer hover:text-gray-300"
                              onClick={() => {
                                setSelectedRequest({
                                  invNum: item.order_number,
                                  action: 2,
                                });
                                setOpenActionModal(true);
                              }}
                            />
                            <MdCheckCircleOutline
                              className="text-[18px] text-blue-500 cursor-pointer hover:text-gray-300"
                              onClick={() => {
                                setSelectedRequest({
                                  invNum: item.order_number,
                                  action: 1,
                                });
                                setOpenActionModal(true);
                              }}
                            />
                          </div>
                        ) : item.status === 1 ? (
                          <p className="text-green-500 text-center">Diterima</p>
                        ) : item.status === 2 ? (
                          <p className="text-red-500 text-center">Ditolak</p>
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="border">
                    <td className="p-2 text-center" colSpan={9}>
                      {isLoadingList ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Tidak ada data OLISA"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {dataList && dataList.count > 0 && dataList.data !== null ? (
        <>
          <div className="mb-4">
            <PagePagination
              offset={reqBody.offset}
              limit={reqBody.limit}
              setOffset={(e) =>
                setReqBody((prevVal) => ({ ...prevVal, offset: e }))
              }
              setLimit={(e) => {
                setReqBody({ offset: 1, limit: e });
              }}
              total={dataList.count}
            />
          </div>
        </>
      ) : null}

      {selectedRequest ? (
        <ModalApproveSfa
          open={openActionModal && selectedRequest}
          setOpen={setOpenActionModal}
          selectedRequest={selectedRequest}
          onSuccessFunc={() => {
            setSelectedRequest(null);
            setReqBody((prevVal) => ({ ...prevVal, offset: 1 }));
            mutateList({ offset: 1, limit: reqBody.limit });
          }}
        />
      ) : null}

      <Popper
        placement="bottom"
        open={Boolean(anchorElMoreProduct)}
        anchorEl={anchorElMoreProduct}
        sx={{ maxWidth: "200px" }}
        modifiers={[
          {
            name: "arrow",
            enabled: true,
          },
        ]}
      >
        <div className="bg-white text-[10px] p-2 rounded-md border text-wrap whitespace-wrap overflow-hidden break-words">
          {moreProductArr.map((item, i) => `${i + 1}. ${item}`).join(", ")}
        </div>
      </Popper>
    </div>
  );
};
export default SfaList;
